const PHONE_MAX_WIDTH = 767;
const BROWSER_WINDOW = window;

export function isStandardsPhone(): boolean { return BROWSER_WINDOW.innerWidth <= PHONE_MAX_WIDTH; }



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-standards/standards-viewport.ts